var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.08329 12.958H1.50777C0.675552 12.958 0 13.6217 0 14.4393C0 15.2559 0.675552 15.9207 1.50777 15.9207H8.08329C8.91551 15.9207 9.59106 15.2559 9.59106 14.4393C9.59106 13.6217 8.91551 12.958 8.08329 12.958Z",
    fill: "#0F6AA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.0001 3.37867C20.0001 2.56214 19.3246 1.89844 18.4934 1.89844H11.9179C11.0857 1.89844 10.4102 2.56214 10.4102 3.37867C10.4102 4.1963 11.0857 4.86 11.9179 4.86H18.4934C19.3246 4.86 20.0001 4.1963 20.0001 3.37867Z",
    fill: "#0F6AA9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87774 3.37856C6.87774 5.24523 5.33886 6.75821 3.43887 6.75821C1.53999 6.75821 0 5.24523 0 3.37856C0 1.51298 1.53999 0 3.43887 0C5.33886 0 6.87774 1.51298 6.87774 3.37856Z",
    fill: "#0F6AA9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 14.3992C19.9998 16.2648 18.4609 17.7777 16.5609 17.7777C14.6621 17.7777 13.1221 16.2648 13.1221 14.3992C13.1221 12.5325 14.6621 11.0195 16.5609 11.0195C18.4609 11.0195 19.9998 12.5325 19.9998 14.3992Z",
    fill: "#0F6AA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.8931707207e31734001da6b2808bbbdf.svg";
export { ForwardRef as ReactComponent };